import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from './store'

interface MainInfoAttendanceRateReturn {
  refValue: ComputedRef<number | null>
  refHref: ComputedRef<string>
  handleClick: () => void
}

export const useMainInfoAttendanceRate = (): MainInfoAttendanceRateReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refValue = computed<number | null>(() => tutorKanbanStore.getTutor?.attendance_rate ?? null)

  const refHref = computed<string>(() => {
    return useAdminRoutes('admin.tutor-attendance-rates.index', { tutor: [tutorKanbanStore.getTutor?.id || 0] }) || ''
  })

  const handleClick = (): void => {
    if (!refHref.value) return
    window.open(refHref.value, '_blank')
  }

  return {
    refValue,
    refHref,
    handleClick,
  }
}
